var _path, _path2, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbnailPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 210,
    viewBox: "0 0 250 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H250V207C250 208.657 248.657 210 247 210H3.00001C1.34315 210 0 208.657 0 207V0Z",
    fill: "#80849B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.673 120H110.053C108.315 120 106.9 118.631 106.9 116.949V91.9127C106.9 90.8536 107.334 89.8164 108.088 89.0669L115.026 82.1798C115.792 81.418 116.811 81 117.894 81H135.672C137.409 81 138.823 82.3674 138.823 84.0481V116.952C138.823 118.633 137.411 120 135.673 120ZM117.894 83.4375C117.467 83.4375 117.065 83.602 116.763 83.9018L109.824 90.7902C109.527 91.0852 109.356 91.4947 109.356 91.9127V116.949C109.356 117.287 109.669 117.562 110.053 117.562H135.672C136.055 117.562 136.367 117.288 136.367 116.952V84.0481C136.367 83.7117 136.055 83.4375 135.672 83.4375H117.894ZM111.812 93.1875H116.109C117.801 93.1875 119.178 91.8201 119.178 90.1406V85.875C119.178 85.2023 118.628 84.6562 117.95 84.6562C117.273 84.6562 116.723 85.2023 116.723 85.875V90.1406C116.723 90.477 116.448 90.75 116.109 90.75H111.812C111.134 90.75 110.584 91.296 110.584 91.9688C110.584 92.6415 111.134 93.1875 111.812 93.1875Z",
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 81,
    width: 33,
    height: 39
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.673 120H110.053C108.315 120 106.9 118.631 106.9 116.949V91.9127C106.9 90.8536 107.334 89.8164 108.088 89.0669L115.026 82.1798C115.792 81.418 116.811 81 117.894 81H135.672C137.409 81 138.823 82.3674 138.823 84.0481V116.952C138.823 118.633 137.411 120 135.673 120ZM117.894 83.4375C117.467 83.4375 117.065 83.602 116.763 83.9018L109.824 90.7902C109.527 91.0852 109.356 91.4947 109.356 91.9127V116.949C109.356 117.287 109.669 117.562 110.053 117.562H135.672C136.055 117.562 136.367 117.288 136.367 116.952V84.0481C136.367 83.7117 136.055 83.4375 135.672 83.4375H117.894ZM111.812 93.1875H116.109C117.801 93.1875 119.178 91.8201 119.178 90.1406V85.875C119.178 85.2023 118.628 84.6562 117.95 84.6562C117.273 84.6562 116.723 85.2023 116.723 85.875V90.1406C116.723 90.477 116.448 90.75 116.109 90.75H111.812C111.134 90.75 110.584 91.296 110.584 91.9688C110.584 92.6415 111.134 93.1875 111.812 93.1875Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.989,
    y: 81,
    width: 39.2889,
    height: 39,
    fill: "#D3D4D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailPlaceholder);
export default __webpack_public_path__ + "static/media/thumbnail-placeholder.2e51b9642918fe86cf20915b3edf0681.svg";
export { ForwardRef as ReactComponent };